//  Name: register
import { Validator } from 'vee-validate';
import { LOGO } from '@/config'
export default {
  data () {
    return {
      logo: LOGO,
      wait_user: false,
      wait_email: false,
      message: null,
      user: {
        username: null,
        first_name: null,
        last_name: null,
        email: null,
        password: null
      }
    }
  },
  watch: {
    'user.username': function (val) {
      this.user.username = val.toLowerCase()
    },
    'user.email': function (val) {
      this.user.email = val.toLowerCase()
    },
    'user.first_name': function (val) {
      var str = val.toLowerCase()
      this.user.first_name = str.replace(/\b\w/g, function(l){ return l.toUpperCase() })
    },
    'user.last_name': function (val) {
      var str = val.toLowerCase()
      this.user.last_name = str.replace(/\b\w/g, function(l){ return l.toUpperCase() })
    }
  },
  methods: {
    register() {
      var vm = this
      vm.$validator.validateAll().then(() => {
        // eslint-disable-next-line
        vm.message = 'Registrando...'
        vm.$http
        .post(
          'users/register/',
          this.user
        ).then(response => {
          console.log(response.body)
          if (response.body.status == 'ok') {
            vm.message = "Ya casi está listo el registro, ahora solo debe validar su correo electrónico dando click al link que te acabamos de enviar"
            // vm.$router.push({name: 'login'})
          } else {
            vm.message = response.body.message
          }
        },
        error => {
          console.error(error)
          vm.message = "Problemas de comunicación con el servidor, intentelo más tarde"
        })
      })
    }
  },
  created () {
    var vm = this
    Validator.extend('verify_username', {
      getMessage: (field) => `Nombre de usuario no está disponible.`,
      validate: (value) => {
        if (value.length > 3) {
          vm.wait_user = true
          return vm.$http.get('users/verify/username/' + value + '/')
          .then(function (result) {
            if (result.body.status == 'ok') {
              vm.wait_user = false
              return Promise.resolve({valid: true})
            } else {
              vm.wait_user = false
              return Promise.resolve({valid: false})
            }
          },
          function (error) {
            vm.wait_user = false
            return Promise.resolve({valid: false})
          })
        }
      }
    })
    Validator.extend('verify_email', {
      getMessage: (field) => `Este correo electrónico ya posee cuenta.`,
      validate: (value) => {
        return vm.$http.get('users/verify/email/' + value + '/')
        .then(function (result) {
          if (result.body.status == 'ok') {
            return Promise.resolve({valid: true})
          } else {
            return Promise.resolve({valid: false})
          }
        },
        function (error) {
          return Promise.resolve({valid: false})
        })
      }
    })
    this.$validator.attach('user.username', 'required|min:4|verify_username')
    this.$validator.attach('user.email', 'required|email|verify_email')
  }
}



// WEBPACK FOOTER //
// ./src/pages/register/script.js